import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import { path } from "d3";
import { element } from "prop-types";
const EmpOnboarding = React.lazy(() => import("@/pages/canditateOnboarding/preOnboarding"));
const BuddyInfo = React.lazy(() => import("@/pages/canditateOnboarding/Buddy"));
const InductionSchedule = React.lazy(() => import("@/pages/canditateOnboarding/Induction"));
const Feedback = React.lazy(() => import("@/pages/canditateOnboarding/feedback"));
const WelcomeAboard = React.lazy(() => import("@/pages/canditateOnboarding/welcome"));

const Onboardingcomponent = [
    {
        path: "canditateOnboarding",
        element: (
            <SuspenseWrapper>
                <EmpOnboarding />
            </SuspenseWrapper>
        ),
    },

    {
        path:"buddyInfo",
        element:(
            <SuspenseWrapper>    
                <BuddyInfo />
            </SuspenseWrapper>
        )
    },
    {
        path:"inductionSchedule",
        element:(
            <SuspenseWrapper>    
                <InductionSchedule />
            </SuspenseWrapper>
        )
    },
    {
        path:"buddyFeedback",
        element:(
            <SuspenseWrapper>    
                <Feedback />
            </SuspenseWrapper>
        )
    },
    {
        path:"welcomeAboard",
        element:(
            <SuspenseWrapper>    
                <WelcomeAboard />
            </SuspenseWrapper>
        )
    }


];

export default Onboardingcomponent;
